import React, { Component, Fragment } from 'react';
import banner from '../resources/banner.jpg';
import { Dialog } from '@blueprintjs/core';
import LoadingButton from './widgets/LoadingButton';
import { RenderInput } from './main/dashboard/modals/Base';

class Landing extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loaded: false
        }
    }
    openContact = () => {
        window.dispatchEvent(new CustomEvent('open-contact-modal'));
    }
    render() {
        const year = (new Date()).getFullYear();
        return (
            <Fragment>
                <div className="landing-page">
                    <div className="jumbotron">
                        <img src={banner} width={'100%'} onLoad={() => this.setState({ loaded: true })} />
                    </div>
                    { this.state.loaded ?
                        <div className="animated fadeIn">
                            <div className="jumbotron">
                                Missions Education Fund is a Christian organization that helps children from economic, social and physical poverty to receive education and enable them to become responsible, mature Christian adults. Today, Missions Education Fund has helped over 1000 students in 19 countries including Sierra Leone, Togo, Congo, Ivory Coast, Ghana, Nigeria, Malawi, Uganda, Kenya, Tanzania, El Salvador, Nicaragua, Honduras, Colombia, Mexico, Jamaica, Dominican Republic, Haiti and Papua New Guinea. Help a child get an education today so they can break the cycle of poverty for generations to come.
                            </div>
                            <div className="jumbotron quote">
                                Give a child hope for the future -- and help break the cycle of poverty. Sponsor a student today!
                            </div>
                            <div className="jumbotron">
                                Your contribution of just $20 a month will help for the basic education needs of a child who otherwise wouldn't have the opportunity to attend school. These needs include but not limited to: Tuition, uniform, transportation and school supplies costs but most importantly, your sponsored child will be encouraged to develop a lifelong relationship with God. We are a charitable organization, and every donation received from Canada and the United States will receive a Tax receipt. Thank you for your support!
                            </div>
                            {/* <div className="jumbotron centered">
                                <div className="contact-button" onClick={this.openContact}>
                                    Contact Us
                                </div>
                            </div> */}
                        </div> : null
                    }
                </div>
                <div className="footer">
                    Copyright {year} Mission Education Fund
                </div>
                <ContactModal />
            </Fragment>
        );
    }
}

class ContactModal extends Component {
    constructor(props) {
        super(props);
        this.emptyForm = {
            first_name: '',
            last_name: '',
            street_address: '',
            city: '',
            state_or_province: '',
            postal_code: '',
            country: '',
            phone_number: '',
            email: '',
            local_church: ''
        };
        this.state = {
            showModal: false,
            isLoading: false,
            form: this.emptyForm
        };
        this.openModal = this.openModal.bind(this);
    }
    componentDidMount() {
        window.addEventListener('open-contact-modal', this.openModal);
    }
    componentWillUnmount() {
        window.removeEventListener('open-contact-modal', this.openModal);
    }
    openModal = () => {
        this.setState({ showModal: true });
    }
    onChangeHandler = ({ text, value }) => {
        const { form } = this.state;
        form[value] = text;
        this.setState({ form });
    }
    closeModal = () => {
        this.setState({ showModal: false, form: this.emptyForm, isLoading: false });
    }
    onContact = () => {
        this.setState({ isLoading: true });
        setTimeout(() => this.closeModal(), 3000);
    }
    render() {
        const { showModal, isLoading, form } = this.state;
        return (
            <Dialog icon='hand'
                style={{ width: '750px'}}
                isOpen={showModal}
                onClose={() => this.closeModal()}
                title="Contact Us">
                { showModal ?
                    <Fragment>
                        <div className="pt-dialog-body">
                            <div className="flex-row">
                                <RenderInput label="First Name"
                                    name="first_name"
                                    value={form.first_name}
                                    autoFocus
                                    onChangeHandler={this.onChangeHandler} />
                                <RenderInput label="Last Name"
                                    name="last_name"
                                    value={form.last_name}
                                    onChangeHandler={this.onChangeHandler} />
                            </div>
                            <div className="flex-row">
                                <RenderInput label="Street Address"
                                    name="street_address"
                                    value={form.street_address}
                                    onChangeHandler={this.onChangeHandler} />
                                <RenderInput label="City"
                                    name="city"
                                    value={form.city}
                                    onChangeHandler={this.onChangeHandler} />
                            </div>
                            <div className="flex-row">
                                <RenderInput label="Province/State"
                                    name="state_or_province"
                                    value={form.state_or_province}
                                    onChangeHandler={this.onChangeHandler} />
                                <RenderInput label="Postal/Zip"
                                    name="postal_code"
                                    value={form.postal_code}
                                    onChangeHandler={this.onChangeHandler} />
                            </div>
                            <div className="flex-row">
                                <RenderInput label="Country"
                                    name="country"
                                    value={form.country}
                                    onChangeHandler={this.onChangeHandler} />
                                <RenderInput label="Phone Number"
                                    name="phone_number"
                                    value={form.phone_number}
                                    onChangeHandler={this.onChangeHandler} />
                            </div>
                            <div className="flex-row">
                                <RenderInput label="E-mail"
                                    name="email"
                                    value={form.email}
                                    onChangeHandler={this.onChangeHandler} />
                                <RenderInput label="Local Church"
                                    name="local_church"
                                    value={form.local_church}
                                    onChangeHandler={this.onChangeHandler} />
                            </div>
                        </div>
                        <div className="pt-dialog-footer">
                            <div className="pt-dialog-footer-actions">
                                <LoadingButton className="pt-button pt-fill pt-intent-primary pt-large" text="Contact" onClick={this.onContact} isLoading={isLoading} />
                            </div>
                        </div>
                    </Fragment> : null
                }
            </Dialog>
        );
    }
}
export default Landing;



// WEBPACK FOOTER //
// ./src/components/Landing.jsx